export default {
	search(params, cb, ecb) {
		this.http
			.get('/order', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/order', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	create(form, cb, ecb) {
		this.http
			.post('/order/create', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	settle(form, cb, ecb) {
		this.http
			.post('/order/settle', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	settleUndo(id, cb, ecb) {
		this.http
			.post('/order/settleUndo/' + id)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	refund(form, cb, ecb) {
		this.http
			.post('/order/refund', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb, ecb) {
		this.http
			.post('/order/remove/' + id)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get('/order/' + id, {}).then((r) => cb && cb(r))
	},
	getItems(id, cb) {
		this.http.get('/order/' + id + '/items', {}).then((r) => cb && cb(r))
	},
	getPayment(id, cb) {
		this.http.get('/order/' + id + '/payment', {}).then((r) => cb && cb(r))
	},
	getPaymentById(id, cb) {
		this.http.get(`/order/payment/${id}`, {}).then((r) => cb && cb(r))
	},
	getRefunds(id, cb) {
		this.http.get('/order/' + id + '/refunds', {}).then((r) => cb && cb(r))
	},
	getPriceLevelDiscount(orderid, levelid, cb) {
		this.http.get('/order/getPriceLevelDiscount', { params: { orderid, levelid } }).then((r) => cb && cb(r))
	}
}
